module.exports = __webpack_public_path__ + "static/media/landing.08e18cb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing.jpg
// module id = 5880
// module chunks = 0